// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"9a476727","185":"a04f8095","242":"c605ea42","253":"33e1867f","305":"87927ed5","311":"71230a6d","379":"5bd02dc9","482":"645f3e4a","499":"20566c85","545":"80253a77","784":"d4267cd7","921":"54560597","975":"e027305c","997":"95282f5a"}[chunkId] + ".chunk.js";
};